import { useTheme } from "@mui/material";
import { appBarHeight } from "../config";

interface ISizeKey {
  heightWithoutAppbar: string;
}

export default function useSize() {
  const theme = useTheme();

  const pxToRem = (pixel: number) => {
    return theme.typography?.pxToRem(pixel);
  };

  const size: ISizeKey = {
    heightWithoutAppbar: `calc(100vh - ${appBarHeight}px)`,
  };

  return {
    pxToRem,
    size,
  };
}
